import React from 'react';
import ColorPicker from '../ui/ColorPicker';

const VideoBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    const newConfig = {
      ...block.config,
      [field]: value,
    };
    onUpdate(block.id, {
      config: newConfig,
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  const extractYouTubeId = (url) => {
    if (!url) return '';
    // Handle various YouTube URL formats
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  };

  const videoId = extractYouTubeId(block.config.videoUrl || '');

  return (
    <div className="video-block-editor">
      <div className="editor-section">
        <h4 className="editor-section-title">Video Settings</h4>

        <div className="editor-field">
          <label>YouTube Video URL</label>
          <input
            type="url"
            value={block.config.videoUrl || ''}
            onChange={(e) => handleChange('videoUrl', e.target.value)}
            placeholder="https://www.youtube.com/watch?v=..."
          />
          <span className="field-hint">
            Paste any YouTube URL format (watch, embed, or short link)
          </span>
        </div>

        {videoId && (
          <div className="video-preview" style={{ marginTop: '1rem', background: '#000', borderRadius: '8px', overflow: 'hidden' }}>
            <iframe
              width="100%"
              height="200"
              src={`https://www.youtube.com/embed/${videoId}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video preview"
            ></iframe>
          </div>
        )}

        <div className="editor-field">
          <label>Video Title (optional)</label>
          <input
            type="text"
            value={block.config.title || ''}
            onChange={(e) => handleChange('title', e.target.value)}
            placeholder="Watch the official video"
          />
        </div>

        <div className="editor-field">
          <label>Description (optional)</label>
          <textarea
            value={block.config.description || ''}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Add a description for your video..."
            rows={3}
            style={{ width: '100%', padding: '0.5rem', background: '#1a1a1a', color: '#fff', border: '1px solid #333', borderRadius: '4px' }}
          />
        </div>

        <div className="editor-field">
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={block.config.autoplay !== false}
              onChange={(e) => handleChange('autoplay', e.target.checked)}
            />
            Autoplay video (not recommended for emails)
          </label>
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Styling</h4>

        <ColorPicker
          label="Background Color"
          color={block.styles.backgroundColor || '#000000'}
          onChange={(color) => handleStyleChange('backgroundColor', color)}
        />

        <ColorPicker
          label="Text Color"
          color={block.styles.color || '#ffffff'}
          onChange={(color) => handleStyleChange('color', color)}
        />
      </div>
    </div>
  );
};

export default VideoBlockEditor;
